import React, { useState } from 'react';

import { Typography } from '@mui/material'

import Container from 'react-bootstrap/Container';
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { SignOutButton } from './office365auth/SignOutButton';

export const getPlanesAcademicos = (studentInfo) => {
    if (studentInfo == null || studentInfo.grados == null) return null;
    let planes = ((!studentInfo.grados) ? [] : studentInfo.grados);
    return planes;
};

const NoPlanesDisponibles = () => {
    return (<>
        <Container>
            <Row>
                <Col>
                    <Typography variant="h6" sx={{ my: 3 }}>
                        Actualmente el portal no esta disponible para tu plan de estudios, consulta a tu coordinador académico.
                    </Typography>

                    <SignOutButton />
                </Col>
            </Row>
        </Container>
    </>);
};

const PlanesAcademicos = ({ planesAcademicos, onPlanChange }) => {
    const [selectedValue, setSelectedValue] = useState(null);

    const onChangeHandler = (id) => {
        onPlanChange(id);
        setSelectedValue(id);
    };

    return <>
        {
            planesAcademicos.map((plan, key) => {
                const radioProps = {
                    className: "form-check-input",
                    type: "radio",
                    name: "planesAcademicos",
                    id: `planAcademico_${plan.programaKey}`,
                    value: plan.planacademico,
                    checked: selectedValue === plan.programaKey,
                };

                return (
                    <label key={key} htmlFor={radioProps.id}
                        className={"form-check plan-academico-radiobutton " + (radioProps.checked ? "checked" : "")}>

                        <input {...radioProps} onChange={() => onChangeHandler(plan.programaKey)} />

                        <label className="form-check-label" htmlFor={`planAcademico_${plan.programaKey}`}
                            style={{ fontWeight: 500 }}>
                            {plan.programa}
                        </label>
                    </label>
                );
            })
        }
    </>
};

export default function SeleccionarPlanAcademico({ studentInfo, onContinuar, onCancelar }) {
    const [selectedPlan, setSelectedPlan] = useState(null);

    if (studentInfo == null || studentInfo.grados == null) return (<>Cargando...</>);

    let planesAcademicos = getPlanesAcademicos(studentInfo);

    //Si el estudiante no tiene planes academicos disponibles
    if (planesAcademicos.length === 0) {
        return <NoPlanesDisponibles />
    }

    if (planesAcademicos.length === 1) {
        onContinuar(planesAcademicos[0].programaKey);
        return null;
    }

    const handlePlanChange = (selectedPlan) => {
        if (!selectedPlan) return;
        setSelectedPlan(selectedPlan);
    };

    const handleContinuar = () => {
        if (!selectedPlan) return;
        onContinuar(selectedPlan);
    };

    const handleCancelar = () => {
        onCancelar();
    };

    return (<>
        <Container>
            <Row>
                <Col>
                    <p>La matrícula encontrada se encuentra activa en más de un programa.</p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className="blue-label">
                        Para continuar, por favor elige cuál deseas usar para generar el Formato Único.
                    </p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <PlanesAcademicos
                        planesAcademicos={planesAcademicos}
                        selectedPlan={selectedPlan}
                        onPlanChange={handlePlanChange} />
                </Col>
            </Row>

            <Row>
                <Col className="d-grid gap-2 mt-5 mb-2">
                    <Button variant="primary" disabled={(!selectedPlan) ? "disabled" : ""} onClick={() => handleContinuar()}>
                        Continuar
                    </Button>
                </Col>
            </Row>

            <Row>
                <Col className="d-grid gap-2 mt-5 mb-2">
                    <Button variant="primary" disabled={(!selectedPlan) ? "disabled" : ""} onClick={() => handleCancelar()}>
                        Regresar
                    </Button>
                </Col>
            </Row>
        </Container>
    </>);
}
